import { IBrief } from "@shared/lib/types/brief";
import { Users } from "lucide-react";
import styles from "../styles.module.scss";

type DefaultPricingPocCardsProps = {
  defaultPricingPoc?: IBrief["defaultPricingPoc"];
  defaultAgencyPricingPoc?: IBrief["defaultAgencyPricingPoc"];
  onSelect: (name: string, userId: string) => void;
};

function getPocName(
  poc?: IBrief["defaultPricingPoc"] | IBrief["defaultAgencyPricingPoc"]
) {
  if (!poc?.user) {
    return "";
  }

  return `${poc.user.firstName ?? ""} ${poc.user.lastName ?? ""}`.trim();
}

export function DefaultPricingPocCards({
  defaultPricingPoc,
  defaultAgencyPricingPoc,
  onSelect,
}: DefaultPricingPocCardsProps) {
  const cards = [
    defaultPricingPoc
      ? {
          key: "direct",
          title: "Default pricing POC",
          name: getPocName(defaultPricingPoc),
          userId: defaultPricingPoc.userId,
        }
      : null,
    defaultAgencyPricingPoc
      ? {
          key: "agency",
          title: "Default agency pricing POC",
          name: getPocName(defaultAgencyPricingPoc),
          userId: defaultAgencyPricingPoc.userId,
        }
      : null,
  ].filter(Boolean) as Array<{
    key: string;
    title: string;
    name: string;
    userId: string;
  }>;

  if (!cards.length) {
    return null;
  }

  return (
    <div className={styles.defaultPocCards}>
      {cards.map((card) => (
        <button
          key={card.key}
          type="button"
          className={styles.defaultPocCard}
          onClick={() => onSelect(card.name, card.userId)}
        >
          <div className={styles.defaultPocCardTitle}>
            <Users size={12} />
            {card.title}
          </div>
          <div className={styles.defaultPocCardName}>{card.name || "—"}</div>
        </button>
      ))}
    </div>
  );
}
